import { Activity } from "lucide-react";

export default function LabBrand() {
  return <div className="flex items-center gap-3">
    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-700 text-white"><Activity size={22} strokeWidth={1.6} /></span>
    <div><div className="text-[13px] font-semibold tracking-tight text-slate-800 sm:text-sm">Virtual Anatomy Lab</div><div className="mt-0.5 text-[9px] font-medium uppercase tracking-[0.2em] text-slate-500">UNSW<span className="hidden sm:inline"> · Learn in three dimensions</span></div></div>
  </div>;
}
